import { createFileRoute } from "@tanstack/react-router";

import { BankTransfers } from "@/features/company/bank-transfers";
import { useEffect } from "react";

import { useInvoiceBrowser } from "@/providers/invoice-browser";

export const Route = createFileRoute(
  "/_authenticated/$company/unternehmen/ueberweisungen",
)({
  component: TransfersPage,
  staticData: {
    breadcrumb: ["transfers.link"],
  },
});

function TransfersPage() {
  const { setInvoiceBrowsingQueue } = useInvoiceBrowser();

  useEffect(() => {
    setInvoiceBrowsingQueue([]);
  }, []);

  return (
    <div className="flex-1 px-4 pb-4 h-full">
      <BankTransfers />
    </div>
  );
}
